import React from 'react'

const WhyChooseUs = () => {
  return (
    <>
      <div className="page-wrapper">
        <section className="section-with-120px-margin">
          <div className="container">
            <div className="_2-column-block">
              <div
                className="contents"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
              >
                <div className="_20px-text-500-primary">Why Choose Us</div>
                <h2>Your gateway to amazing experiences and memories</h2>
                <div className="margin-top-10px">
                  <p className="_20px-text">
                    We have been operating for over a decade, providing
                    top-notch services to our clients and building a strong
                    track record
                  </p>
                </div>
                <div className="w-layout-vflex list-item">
                  <div className="horizontal-left-center-10px-gap">
                    <img
                      src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a405410e4b22f9acd0b3_%EF%81%BC.png"
                      loading="lazy"
                      alt=""
                      className="image-25px"
                    />
                    <div className="_18px-text-600">
                      Adventure awaits around every corner
                    </div>
                  </div>
                  <div className="horizontal-left-center-10px-gap">
                    <img
                      src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a405410e4b22f9acd0b3_%EF%81%BC.png"
                      loading="lazy"
                      alt=""
                      className="image-25px"
                    />
                    <div className="_18px-text-600">Roam free, wander often</div>
                  </div>
                  <div className="horizontal-left-center-10px-gap">
                    <img
                      src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a405410e4b22f9acd0b3_%EF%81%BC.png"
                      loading="lazy"
                      alt=""
                      className="image-25px"
                    />
                    <div className="_18px-text-600">
                      Create memories that last a lifetime
                    </div>
                  </div>
                  <div className="horizontal-left-center-10px-gap">
                    <img
                      src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a405410e4b22f9acd0b3_%EF%81%BC.png"
                      loading="lazy"
                      alt=""
                      className="image-25px"
                    />
                    <div className="_18px-text-600">Roam free, wander often</div>
                  </div>
                  <div className="horizontal-left-center-10px-gap">
                    <img
                      src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a405410e4b22f9acd0b3_%EF%81%BC.png"
                      loading="lazy"
                      alt=""
                      className="image-25px"
                    />
                    <div className="_18px-text-600">
                      Create memories that last a lifetime
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="image-wrapper-50 max-520"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
              >
                <img
                  src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232681/ASP_xsndo1_uj0rvs.png"
                  loading="lazy"
                  sizes="(max-width: 991px) 100vw, 60vw"
                  srcSet="
                            https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232681/ASP_xsndo1_uj0rvs.png
                        "
                  alt=""
                />
                {/* <img
                  src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66baf0762eec02e80406fa53_Group%201000008328.avif"
                  loading="lazy"
                  style={{
                    opacity: 1,
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                  data-w-id="f19c7d7f-0a2c-5206-8aa2-fbb15c77b5bc"
                  alt=""
                  className="client-review-image"
                /> */}
              </div>
            </div>
          </div>
        </section>
        <section
          data-w-id="d901a8dd-d20a-460d-2933-9342a4f67cc3"
          style={{
            opacity: 1,
            transform:
              "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
            transformStyle: "preserve-3d",
          }}
          className="section-with-120px-margin"
        >
          <div className="container overflow-hidden">
            <div
              data-w-id="d901a8dd-d20a-460d-2933-9342a4f67cc4"
              style={{
                transform:
                  "translate3d(-96.778vw, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                transformStyle: "preserve-3d",
                willChange: "transform",
              }}
              className="logo-container"
            >
              <img
                loading="lazy"
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8fb178fa9afe7f5d5e_Group-1.avif"
                alt=""
                className="logo-image"
              />
              <img
                loading="lazy"
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8f90bc3625ce9e838b_Group-2.avif"
                alt=""
                className="logo-image"
              />
              <img
                loading="lazy"
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8fbe961554747d86cc_Group.avif"
                alt=""
                className="logo-image"
              />
              <img
                loading="lazy"
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8ef20d7dc9b85b792e_OBJECTS.avif"
                alt=""
                className="logo-image"
              />
              <img
                loading="lazy"
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8ee838030a66277553_Group-3.avif"
                alt=""
                className="logo-image"
              />
              <img
                loading="lazy"
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8fb178fa9afe7f5d5e_Group-1.avif"
                alt=""
                className="logo-image"
              />
              <img
                loading="lazy"
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8f90bc3625ce9e838b_Group-2.avif"
                alt=""
                className="logo-image"
              />
              <img
                loading="lazy"
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8fbe961554747d86cc_Group.avif"
                alt=""
                className="logo-image"
              />
              <img
                loading="lazy"
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8ef20d7dc9b85b792e_OBJECTS.avif"
                alt=""
                className="logo-image"
              />
              <img
                loading="lazy"
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8ee838030a66277553_Group-3.avif"
                alt=""
                className="logo-image"
              />
            </div>
          </div>
        </section>
        <section className="section-with-120px-margin black">
          <div className="container">
            <div className="title-wrapper">
              <div className="mask">
                <div
                  className="fancy-title-20px"
                  style={{
                    opacity: 1,
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                >
                  Travel Resources
                </div>
              </div>
              <div className="mask">
                <h2
                  data-w-id="efb1f925-74fc-914c-b350-e7db2acab8af"
                  style={{
                    opacity: 1,
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                  className="text-white"
                >
                  Where Every Trip is <br />
                  an <span className="font-color-primary">Adventure</span>
                </h2>
              </div>
            </div>
            <div
              className="slide-in-from-bottom-delayed w-dyn-list"
              style={{
                opacity: 1,
                transform:
                  "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                transformStyle: "preserve-3d",
              }}
            >
              <div
                role="list"
                className="vertical-left-stretch-30px-gap w-dyn-items"
              >
                <div role="listitem" className="w-dyn-item">
                  <div
                    data-w-id="5bde2b7c-325c-c910-7713-f3df646dc531"
                    className="blog-list-card"
                  >
                    <a
                      href="#"
                      className="destination-thumbnail-wrapper w-inline-block"
                    >
                      <img
                        src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232659/pexels-redrum-visuals-5819209_mbfstl_rnmv82.jpg"
                        loading="lazy"
                        alt=""
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 95vw, (max-width: 991px) 96vw, 33vw"
                        srcSet="
                                       https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232659/pexels-redrum-visuals-5819209_mbfstl_rnmv82.jpg
                                    "
                        className="destination-thumbnail"
                        style={{
                          transform:
                            "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                        }}
                      />
                    </a>
                    <div className="w-layout-vflex destination-body">
                      <h3 className="_24px-text-white">
                        Where wanderlust meets wanderlove
                      </h3>
                      <p className="_20px-white-text">
                        We have been operating for over a decade, providing
                        top-notch services to our clients and building a strong
                        track record
                      </p>
                    </div>
                    <a
                      data-w-id="05cb0bd0-f5ce-2467-1637-e9dd36acdada"
                      href="/blog/where-wanderlust-meets-wanderlove"
                      className="destination-button w-inline-block"
                      style={{
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        color: "rgb(252, 252, 252)",
                      }}
                    >
                      <div className="button-text-wrapper">
                        <div className="default-text">Read More</div>
                        <div className="hover-text">Read More</div>
                      </div>
                      <div className="icon">east</div>
                    </a>
                    <div
                      style={{
                        width: "0%",
                        height: "222px",
                      }}
                    ></div>
                  </div>
                </div>
                <div role="listitem" className="w-dyn-item">
                  <div
                    data-w-id="5bde2b7c-325c-c910-7713-f3df646dc531"
                    className="blog-list-card"
                  >
                    <a
                      href="#"
                      className="destination-thumbnail-wrapper w-inline-block"
                    >
                      <img
                        src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232640/pexels-pth686817-20761897_fdyqiu_rtxeif.jpg"
                        loading="lazy"
                        alt=""
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 95vw, (max-width: 991px) 96vw, 33vw"
                        srcSet="
                                       https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232640/pexels-pth686817-20761897_fdyqiu_rtxeif.jpg
                                    "
                        className="destination-thumbnail"
                        style={{
                          transform:
                            "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                        }}
                      />
                    </a>
                    <div className="w-layout-vflex destination-body">
                      <h3 className="_24px-text-white">
                        Transforming dreams into itineraries
                      </h3>
                      <p className="_20px-white-text">
                        We have been operating for over a decade, providing
                        top-notch services to our clients and building a strong
                        track record
                      </p>
                    </div>
                    <a
                      data-w-id="05cb0bd0-f5ce-2467-1637-e9dd36acdada"
                      href="/blog/transforming-dreams-into-itineraries"
                      className="destination-button w-inline-block"
                      style={{
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        color: "rgb(252, 252, 252)",
                      }}
                    >
                      <div className="button-text-wrapper">
                        <div className="default-text">Read More</div>
                        <div className="hover-text">Read More</div>
                      </div>
                      <div className="icon">east</div>
                    </a>
                    <div
                      style={{ width: "0%", height: "222px" }}
                      className="hover-color"
                    ></div>
                  </div>
                </div>
                <div role="listitem" className="w-dyn-item">
                  <div
                    data-w-id="5bde2b7c-325c-c910-7713-f3df646dc531"
                    className="blog-list-card"
                  >
                    <a
                      href="#"
                      className="destination-thumbnail-wrapper w-inline-block"
                    >
                      <img
                        src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232639/pexels-raul-tirado-269095585-12784412_pvziay_rvnqi4.jpg"
                        loading="lazy"
                        alt=""
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 95vw, (max-width: 991px) 96vw, 33vw"
                        srcSet="
                                       https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232639/pexels-raul-tirado-269095585-12784412_pvziay_rvnqi4.jpg
                                    "
                        className="destination-thumbnail"
                        style={{
                          transform:
                            "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                        }}
                      />
                    </a>
                    <div className="w-layout-vflex destination-body">
                      <h3 className="_24px-text-white">
                        Escape ordinary embrace the extraordinary
                      </h3>
                      <p className="_20px-white-text">
                        We have been operating for over a decade, providing
                        top-notch services to our clients and building a strong
                        track record
                      </p>
                    </div>
                    <a
                      data-w-id="05cb0bd0-f5ce-2467-1637-e9dd36acdada"
                      href="/blog/escape-ordinary-embrace-the-extraordinary"
                      className="destination-button w-inline-block"
                      style={{
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        color: "rgb(252, 252, 252)",
                      }}
                    >
                      <div className="button-text-wrapper">
                        <div className="default-text">Read More</div>
                        <div className="hover-text">Read More</div>
                      </div>
                      <div className="icon">east</div>
                    </a>
                    <div
                      style={{
                        width: "0%",
                        height: "222px",
                      }}
                      className="hover-color"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section-with-120px-margin">
          <div className="container">
            <div className="_2-column-block">
              <div
                data-w-id="24fd8113-8462-c394-aed6-9e0bf01b6f0d"
                className="image-wrapper-50"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
              >
                <img
                  src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232685/2_fvrefs_ambqy1.png"
                  loading="lazy"
                  sizes="(max-width: 991px) 100vw, 58vw"
                  srcSet="
                           https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232685/2_fvrefs_ambqy1.png
                        "
                  alt=""
                  className="landscape-image"
                />
              </div>
              <div
                className="contents"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
              >
                <h2>Wanderlust Unleashed Discover Path Embrace Journeys</h2>
                <div className="margin-top-20px">
                  <p className="_20px-text">
                    We have been operating for over a decade, providing
                    top-notch the services to our clients and building a strong
                    track record We have been operating for over a decade,
                    providing top-notch
                  </p>
                </div>
              </div>
            </div>
            <div className="_2-column-block">
              <div
                className="contents"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
              >
                <h2>Roam Freely Adventure AwaitsTravel Beyond Limits</h2>
                <div className="margin-top-20px">
                  <p className="_20px-text">
                    We have been operating for over a decade, providing
                    top-notch the services to our clients and building a strong
                    track record We have been operating for over a decade,
                    providing top-notch
                  </p>
                </div>
              </div>
              <div
                className="image-wrapper-50"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
              >
                <img
                  src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232705/1_goi9cz_of7s0l.png"
                  loading="lazy"
                  sizes="(max-width: 479px) 100vw, (max-width: 767px) 95vw, (max-width: 991px) 96vw, 46vw"
                  srcSet="
                          https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232705/1_goi9cz_of7s0l.png
                        "
                  alt=""
                  className="landscape-image"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="section-with-120px-margin">
          <div className="container">
            <div className="title-wrapper">
              <div className="mask">
                <div
                  className="fancy-title-20px"
                  style={{
                    opacity: 1,
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                >
                  Our Team Member
                </div>
              </div>
              <div className="mask">
                <h2
                  data-w-id="9669d5ab-d935-a4f5-26d3-74b4096c65d3"
                  style={{
                    opacity: 1,
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                >
                  Our <span className="font-color-primary">Exclusive</span> Travel{" "}
                  <br />
                  Packages
                </h2>
              </div>
            </div>
            <div
              data-w-id="3d8480c6-335c-7053-677f-dc489ba59d96"
              style={{
                opacity: 1,
                transform:
                  "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                transformStyle: "preserve-3d",
              }}
              className="_3-column-grid"
            >
              <div
                data-w-id="d5159e77-fe44-82cc-5ad6-f94276a58ede"
                className="team-card"
              >
                <img
                  src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232611/1_auuc2l_jn3vpf.png"
                  loading="lazy"
                  alt=""
                  className="team-thumbnail"
                />
                <div className="w-layout-vflex vertical-center-align _5px-gap">
                  <h3 className="_24px-text">Fitsum Yohannes</h3>
                  <p className="_20px-text">Eristar Adventures</p>
                </div>
                <div
                  className="absolute-vertical"
                  style={{
                    transform:
                      "translate3d(0px, 100px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                    opacity: 0,
                  }}
                >
                  <a
                    href="https://twitter.com/ThemeNcode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                  <a
                    href="https://twitter.com/ThemeNcode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                  <a
                    href="https://pinterest.com/ThemeNcode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                  <a
                    href="https://www.linkedin.com/company/themencode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                </div>
              </div>
              <div
                className="team-card"
                style={{
                  backgroundColor: "rgb(3 195 255 / 20%)",
                }}
              >
                <img
                  src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232621/2_zpkcfc_kgxq1g.png"
                  loading="lazy"
                  alt=""
                  className="team-thumbnail"
                />
                <div className="w-layout-vflex vertical-center-align _5px-gap">
                  <h3 className="_24px-text" style={{ color: "rgb(25, 27, 26)" }}>
                    Kibrom Eyob Suim
                  </h3>
                  <p className="_20px-text" style={{ color: "rgb(91, 91, 91)" }}>
                    Eristar Tours
                  </p>
                </div>
                <div
                  className="absolute-vertical"
                  style={{
                    transform:
                      "translate3d(0px, 100px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                    opacity: 0,
                  }}
                >
                  <a
                    href="https://twitter.com/ThemeNcode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                  <a
                    href="https://twitter.com/ThemeNcode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                  <a
                    href="https://pinterest.com/ThemeNcode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                  <a
                    href="https://www.linkedin.com/company/themencode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                </div>
              </div>
              <div className="team-card">
                <img
                  src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232630/3_kzo4bu_moph2k.png"
                  loading="lazy"
                  alt=""
                  className="team-thumbnail"
                />
                <div className="w-layout-vflex vertical-center-align _5px-gap">
                  <h3 className="_24px-text">Moses Terulaga</h3>
                  <p className="_20px-text">Eristar Tours</p>
                </div>
                <div
                  className="absolute-vertical"
                  style={{
                    transform:
                      "translate3d(0px, 100px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                    opacity: 0,
                  }}
                >
                  <a
                    href="https://twitter.com/ThemeNcode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                  <a
                    href="https://twitter.com/ThemeNcode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                  <a
                    href="https://pinterest.com/ThemeNcode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                  <a
                    href="https://www.linkedin.com/company/themencode"
                    target="_blank"
                    className="team-social-icon"
                  >
                    
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section-with-120px-margin">
          <div className="container">
            <div className="_2-column-block">
              <div
                className="image-wrapper-50"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
              >
                <img
                  src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232674/tower_xovwgg_gbhpi7.png"
                  loading="lazy"
                  sizes="(max-width: 991px) 100vw, 60vw"
                  srcSet="
                            https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232674/tower_xovwgg_gbhpi7.png
                        "
                  alt=""
                />
                <img
                  src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66bafadd504d59e3f6b8a7b6_Group%208594.avif"
                  loading="lazy"
                  alt=""
                  className="best-awarded"
                />
                <img
                  src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66bafaa27ee3594aa8161af1_Group%208581.png"
                  loading="lazy"
                  alt=""
                  className="absolute-top-right-svg"
                />
              </div>
              <div
                className="contents"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
              >
                <div className="margin-bottom-10px">
                  <div
                    className="fancy-title-20px"
                    style={{
                      opacity: 1,
                      transform:
                        "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                      transformStyle: "preserve-3d",
                    }}
                  >
                    Our Popular Tour
                  </div>
                </div>
                <h2 className="margin-bottom-20px">
                  Traveling opens doors to new adventures
                </h2>
                <p>
                  Traveling opens doors to new adventures, cultures, and
                  experiences. Whether exploring exotic
                </p>
                <div className="animation-counter-wrapper">
                  <div className="counter-percantage">
                    <div>Adventure Travel</div>
                    <div className="counter-animation-line">
                      <div className="default-line"></div>
                      <div
                        className="animated-line _95"
                        style={{ width: "100%", height: "10px" }}
                      >
                        <div className="percentage-counter" style={{ opacity: 1 }}>
                          <div>95%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="counter-percantage">
                    <div>Customized Itineraries</div>
                    <div className="counter-animation-line">
                      <div className="default-line"></div>
                      <div
                        className="animated-line _85"
                        style={{ width: "100%", height: "10px" }}
                      >
                        <div className="percentage-counter" style={{ opacity: 1 }}>
                          <div>85%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="counter-percantage">
                    <div>Corporate Travel</div>
                    <div className="counter-animation-line">
                      <div className="default-line"></div>
                      <div
                        className="animated-line _75"
                        style={{ width: "100%", height: "10px" }}
                      >
                        <div className="percentage-counter" style={{ opacity: 1 }}>
                          <div>70%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default WhyChooseUs
